import ayanna from '../assets/ayanna.jpeg';
import kaylee from '../assets/kaylee.png';
import brandy from '../assets/brandy.png';
import group1 from '../assets/group1.png';
import profile3 from '../assets/profile3.png';
import chidinma from '../assets/chidinma.png';
import ijeoma from '../assets/ijeoma.png';
import kemi from '../assets/kemi.png';
import mycherie from '../assets/mycherie.png';
import top4 from '../assets/top4.png';
import top2 from '../assets/top2.png';
import top3 from '../assets/top3.png';
import sub1 from '../assets/sub1.png';
import sub2 from '../assets/sub2.png';
import sub3 from '../assets/sub3.png';
import sub4 from '../assets/sub4.png';
import sub5 from '../assets/sub5.png';
import sub6 from '../assets/sub6.png';
import sub7 from '../assets/sub7.png';
import sub8 from '../assets/sub8.png';
import sub9 from '../assets/sub9.png';
import sub10 from '../assets/sub10.png';
import sub11 from '../assets/sub11.png';
import sub12 from '../assets/sub12.png';
import sub13 from '../assets/sub13.png';
import sub14 from '../assets/sub14.png';
import sub15 from '../assets/sub15.png';
import profile from '../assets/profile.png';
import ayomide from '../assets/ayomide.png';
import logo from '../assets/logo.png';
import sharon from '../assets/sharon.png';
import love from '../assets/love.png';
import testimony from '../assets/testimony.png';
import dance from '../assets/dance.png';
import chris from '../assets/chris.png';
import new1 from '../assets/new1.png';
import new2 from '../assets/new2.png';
import new3 from '../assets/new3.png';
import new4 from '../assets/new4.png';
import new5 from '../assets/new5.png';
import new6 from '../assets/new6.png';
import new7 from '../assets/new7.png';
import new8 from '../assets/new8.png';
import new9 from '../assets/new9.png';
import new10 from '../assets/new10.png';
import brandy2 from '../assets/brandy2.png';
import ijeoma2 from '../assets/ijeoma2.png';
import camp1 from '../assets/camp1.jpeg';
import camp2 from '../assets/camp2.jpeg';
import camp3 from '../assets/camp3.jpeg';
import ayannam from '../assets/ayanna.m.png';


const images = {
  camp1,
  camp2,
  camp3,
  ijeoma2,
  ayanna,
  brandy,
  group1,
  profile3,
  kemi,
  ijeoma,
   chidinma,
   mycherie,
  top4,
  top2,
  top3,
  sub1,
  sub2,
  sub3,
  sub4,
  sub5,
  sub6,
  sub7,
  sub8,
  sub9,
  sub10,
  sub11,
  sub12,
  sub13,
  sub14,
  sub15,
  ayomide,
  sharon,
  profile,
  love,
  logo,
  testimony,
  dance,
  chris,
 brandy2,
 kaylee,
 new1,
 new2,
 new3,
 new4,
 new5,
 new6,
 new7,
 new8,
 new9,
 new10,
 ayannam
  // skype,
  // spotify,
};
export default images;